import React, { Fragment, useEffect, useRef } from 'react'
import Typography from '@material-ui/core/Typography'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Grid from '@material-ui/core/Grid'
import QuestionContainer from './QuestionContainer'
import { Field, change } from 'redux-form'
import { makeStyles, withStyles  } from '@material-ui/core/styles'
import { required } from '../../../../utilties/validators'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import FocusTrap from 'focus-trap-react'
import FilledInputSelect from '../../../../components/FilledInputSelect'
import { useSyncRefHeight } from '../../../../utilties/utilities'

const requiredValidator = required

const useStyles = makeStyles((theme) => ({
	label: {
		margin: '0',
		[theme.breakpoints.down('sm')]: {
			padding: '0'
		},
		'$&svg': {
			width: '2em',
			height: '2em'
		}
	},
	radioWrap: {
		width: '26px',
		[theme.breakpoints.down('xs')]: {
			width: '19px',
			display: 'flex'
		},
	},
	radioGroupWrap: {
		minHeight: '33px',
		flexDirection: 'row',	
	},

	radioGroupItem: {
		flexWrap: 'nowrap',
		paddingBottom: '5px',
		[theme.breakpoints.down('md')]: {
			marginBottom: '16px',
		},
	},
	radioGroupHeaderText: {
		'& > div': {
			paddingLeft: '7px'
		}
	}
}))

const FormControlLabelCustom = ({
	showError,
	input,
	value,
	i,
	errorCallback,
	meta: { touched, invalid, error, form, dispatch, submitFailed },
	categoryId,
	disabled,
	...custom
}) => {
	if(input.value === i.toString() && custom.optionChecked[categoryId] != i) {
		dispatch(change(form, input.name, null))
	}

	return (
		<Grid>
			<FormControlLabel
				data-testid="grouped-question"
				style={{ color: 'black' }}
				control={
					<Grid direction='row'>
						<Grid item>
							<Radio  color="primary" value={i.toString()} checked={i.toString() === input.value} disabled={disabled}/>
						</Grid>
					</Grid>
				}
				labelPlacement='end'
				error={touched && invalid}
				helperText={touched && error}
				errorCallback={errorCallback && errorCallback(submitFailed && error)}
				//value={value}
				key={i}
				checked={custom.optionChecked[categoryId] == i}
				{...input}
				{...custom}
			/>
		</Grid>
	)
}

const renderBubble = (
	minimumValue,
	range,
	questionType,
	uniqueId,
	categoryId,
	disabled,
	classes,
	errorCallback,
	isOptional,
	optionChecked,
	setOptionChecked,
	uniqueKey
) => {
	const name = `answers.grouped._${uniqueId}._${categoryId}._${uniqueKey ?? ''}`

	let bubbles = []
	let validators = isOptional ? null : requiredValidator

	for (let index = minimumValue; index <= range; index++) {
		let r = (
			<Grid item classes={{ root: classes.radioWrap }}>
				<Field
					data-testid="grouped-question-field"
					disabled={disabled}
					component={FormControlLabelCustom}
					classes={{ root: classes.label }}
					name={name}
					i={index}
					value={index}
					showError={index == range - 1 ? true : false}
					validate={validators}
					errorCallback={index === minimumValue && errorCallback}
					optionChecked={optionChecked}
					categoryId={categoryId}
					key={index}
				/>
			</Grid>
		)
		bubbles.push(r)
	}
	return bubbles
}

const renderKey = (from, to, classes) => {

	let bubbles = []
	for (let index = from; index <= to; index++) {
		let r = (
			<Grid data-testid="grouped-question-subtitle" item classes={{ root: classes.radioWrap }}>
				<Typography variant='subtitle1' style={{textAlign: 'center'}}>{index}</Typography>
			</Grid>
		)
		bubbles.push(r)
	}
	return bubbles
}

const renderDropdown = (
	minimumValue,
	range,
	categoryId,
	savedValue,
	question,
	onChange,
	disabled,
	errorCallback,
	optionChecked,
	uniqueKey
) => {
	const name = `answers.grouped._${question.uniqueId}._${categoryId}._${uniqueKey ?? ''}`

	let arr = [...Array(range).keys()]
	let validators = question.isOptional ? null : requiredValidator

	return <Field
		data-testid="writable-grouped-dropdown"
		disabled={disabled}
		component={DropDownCustom}
		name={name}
		savedValue={savedValue}
		validate={validators}
		errorCallback={errorCallback}
		question={question}
		categoryId={categoryId}
		optionChecked={optionChecked}
		changeHandler={onChange}
		uniqueKey={uniqueKey}
		data={Array(range + 1)
			.fill()
			.map((_v, i) => {
				return {
					name: i,
					value: i
				}
			})
			.filter((_, i) => i >= minimumValue)
		}
	/>
}

const DropDownCustom = ({
	input,
	value,
	question,
	categoryId,
	i,
	errorCallback,
	changeHandler,
	data,
	disabled,
	savedValue,
	meta: { form, dispatch },
	optionChecked,
	uniqueKey
}) => {
	const name = input?.name || `answers.grouped._${question.uniqueId}._${categoryId}._${uniqueKey ?? ''}`

	useEffect(
		() => {
            if (!input.value && (savedValue || savedValue === 0)) {
				dispatch(change(form, input.name, savedValue.toString()))
			}
        },
        [savedValue]
    )

	if (input.value && !optionChecked[categoryId] && optionChecked[categoryId] !== 0) {
		dispatch(change(form, input.name, null))
	}

	return (
		<Grid>
			<FilledInputSelect
				name={name}
				data={data}
				onChange={changeHandler}
				style={{ color: 'black' }}
				fullWidth
				errorCallback={errorCallback}
				disabled={disabled}
			/>
		</Grid>
	)
}

const CategoryItem = ({
	isLabelContainerPreserved,
	question,
	r,
	changeHandler,
	disabled,
	errorCallback,
	optionChecked,
	setOptionChecked,
	uniqueKey,
	trapIsActive
}) => {
	const itemsRef = useRef(null)

	const classes = useStyles()

	
	useSyncRefHeight(
		[
			[`grouped_items_${r.id}`, itemsRef],
		],
		[ r ],
	)
	
	
	return (
		<div
			ref={itemsRef}
		>
			{
				question.isDropdown
					? <Grid container data-testid="dropdown-component-range" className="range-component" style={{ width: '100%' }} key={r.id}>
						{
							!!isLabelContainerPreserved
							&& <Grid item xs={10} sm={6} className="range-component-label">
								<Typography
									data-testid="writable-grouped-title"
									variant='subtitle1'
								>
									{r.label}
								</Typography>
							</Grid>
						}

						<Grid item xs={isLabelContainerPreserved ? 2 : 4} sm={isLabelContainerPreserved ? 2 : 4}>
							{renderDropdown(
								question.minimumValue,
								question.range,
								r.id,
								r.value,
								question,
								e => changeHandler(e, r),
								disabled, 
								errorCallback,
								optionChecked,
								uniqueKey
							)}
						</Grid>
					</Grid>
					: <Grid classes={{ root: classes.radioGroupItem }} container
						>
						{
							!!isLabelContainerPreserved
							&& <Grid item xs={12} sm={6}>
								<Typography
									variant='subtitle1'
									style={{ fontSize: '17px', fontWeight: '400', paddingRight: '10px' }}>
									{r.label}
								</Typography>
							</Grid>
						}

						<Grid item xs={12} sm={ !!isLabelContainerPreserved ? 6 : 12 }>
							<FocusTrap active={trapIsActive[r.id] === true}
								focusTrapOptions={{
									returnFocusOnDeactivate: false
								}}>
								<RadioGroup
									data-testid="grouped-question-container-radiogroup"
									classes={{ root: classes.radioGroupWrap }}
									onChange={
										(e) => {
											changeHandler(e, r)
										}
									}
									id={'answers.grouped._' + question.uniqueId + '._' + r.id}>
									{renderBubble(
										question.minimumValue,
										question.range,
										question.questionType,
										question.uniqueId,
										r.id,
										disabled,
										classes,
										errorCallback,
										question.isOptional,
										optionChecked,
										setOptionChecked,
										uniqueKey
									)}
								</RadioGroup>
							</FocusTrap>
						</Grid>
					</Grid>
			}
		</div>
	)
}


export default ({
	question,
	position,
	positionDisplay,
	disabled,
	onQuestionValueChanged,
	isBilateral,
	isBilateralFullInfo,
	displayInstructionAsIcon,
	uniqueKey
}) => {
	const isLabelContainerPreserved = !isBilateral || !!isBilateralFullInfo

	const classes = useStyles()
	const dispatch = useDispatch()

	const [ error, setError ] = useState('')
	const [optionChecked, setOptionChecked] = useState([])
	const [canRemoveAnswer, setCanRemoveAnswer] = useState(false)
	const [ trapIsActive, setTrapIsActive ] = useState({})

	const errorCallback = (currentError) => {
		if(!!error !== !!currentError)
			setError(error || currentError)
	}

	const onRemoveAnswer = () => {
		question.categories.map((category) => {
			if (!!category.value) {
				onQuestionValueChanged(question, null, undefined, category)
			}
		})

		setOptionChecked([])
		setCanRemoveAnswer(false)
	}

	const changeHandler = (e, r) => {
		const value = e.target.value != null && e.target.value != undefined ? e.target.value : null

		dispatch(change(e.target.name, value))

		let _optionChecked = optionChecked;

		_optionChecked[r.id] = value;

		setOptionChecked([..._optionChecked])
		setCanRemoveAnswer(true)
		setError('')

		onQuestionValueChanged(question, value, undefined, r)
	}

	useEffect(
		() => {
			question.categories.forEach(category => {
				const name = `answers.grouped._${question.uniqueId}._${category.id}._${uniqueKey ?? ''}`

				if (document.getElementById(name) !== null) {
					document.getElementById(name).addEventListener('keydown', (e)=>{
						if (e.keyCode === 13) {
							e.preventDefault()
							let newState = { ...trapIsActive }
							newState[category.id] = true
							setTrapIsActive(newState)
						}
						if (e.keyCode === 27) {
							e.preventDefault()
							let newState = { ...trapIsActive }
							newState[category.id] = false
							setTrapIsActive(newState)
						}
					})
				}
				
			});
		},
		[]
	)

	return (
		<Grid style={{ width: '100%' }}>
			<QuestionContainer
				data-testid="grouped-question-container"
				title={`${question.title}`} titleRequered = {`${question.isOptional ? '' : ' *'}`}
				position={position}
				positionDisplay={positionDisplay}
				instructions={question.instructions}
				canRemoveAnswer={question.isOptional && canRemoveAnswer}
				onRemoveAnswer={onRemoveAnswer}
				isBilateral={isBilateral}
				displayInstructionAsIcon={displayInstructionAsIcon}
				children={
					<Fragment>
						{question && !question.isDropdown && 
						<Grid container 
							data-testid="grouped-question-header"
							classes={{ root: classes.radioGroupHeader }} 
							style={{ paddingBottom: '5px' }}
							className= { isBilateral ? 'bilateral-radiogroup-header-text' : ''}
						>
							{
								!!isLabelContainerPreserved
								&& <Grid item xs={6} style={{ paddingRight: '10px' }}></Grid>
							}

							<Grid 
								item							
								xs={ !!isLabelContainerPreserved ? 6 : 12 }								
							>
								<Grid container className="radio-group-header-text" classes={{ root: classes.radioGroupHeaderText }}>
									{renderKey(question.minimumValue, question.range, classes)}
								</Grid>
							</Grid>
						</Grid>}
						{question &&
							question.categories &&
							question.categories.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1)).map((r) => {
								return (
									<CategoryItem
										isLabelContainerPreserved={isLabelContainerPreserved}
										question={question}
										r={r}
										changeHandler={changeHandler}
										disabled={disabled}
										errorCallback={errorCallback}
										optionChecked={optionChecked}
										setOptionChecked={setOptionChecked}
										uniqueKey={uniqueKey}
										trapIsActive={trapIsActive}
										key={r.id}
									/>
								)
							})}
						
						<Grid item>
							{error && (
								<span data-testid="grouped-question-container-error" className="errorWrapper">{error}</span>
							)}
						</Grid>
					</Fragment>
				}
			/>
		</Grid>
	)
}
